<template>
  <b-modal id="bv-modal-info"
           :ok-only="true"
           @hide="onHide"
           @ok="onOk"
           ref="modal"
           ok-variant="plm-primary"
           data-test-path="dialog-info"
  >
    <template v-slot:modal-title>
      {{ title }}
    </template>
    <div v-html="message" v-if="!htmlMessage" class="d-block text-center"></div>
    <div v-else v-html="htmlMessage" class="d-block text-center"></div>
  </b-modal>

</template>

<script>

export default {
  name: "InfoDialog",
  async beforeMount() {
  },
  methods: {


    async onHide(ev) {
      if (this.resolve != null) {
        this.resolve(true);
        this.resolve = null;
        this.title = "";
        this.message = "";
        this.htmlMessage = "";
      }
      this.$refs.modal.hide();
    },

    async onOk(ev) {
      if (this.resolve != null) {
        this.resolve(true);
        this.resolve = null;
      }
    },

    reset() {
      this.resolve = null;
      this.title = ""
      this.message = "";
      this.htmlMessage = "";
    }
  },
  data: () => ({
    title: "title",
    message: "message",
    htmlMessage: "",
    resolve: null,
  })
}
</script>
